var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"upload no-trans"},[_c('form',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],attrs:{"id":"uploadForm"}},[_c('input',{ref:"fileRef",attrs:{"type":"file"},on:{"change":_vm.fileChange}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }